export const STOCK_TAG_WRITES_PER_ITEM = 2;
export const FIRESTORE_BATCH_LIMIT = 500;
export const STOCK_TAG_BATCH_ITEM_LIMIT = FIRESTORE_BATCH_LIMIT / STOCK_TAG_WRITES_PER_ITEM;

export type StockTagWriteTarget = 'stock' | 'cache';

export interface IPlannedStockTagWrite {
  stockId: string;
  tags: string[];
  target: StockTagWriteTarget;
}

/**
 * Groups stock and cache tag writes so each Firestore batch stays under the write limit
 * and never splits a stock document from its cache document.
 */
export function planStockTagWriteBatches(
  taggedItems: Record<string, string[]>,
): IPlannedStockTagWrite[][] {
  const stockIds: string[] = Object.keys(taggedItems);
  const batches: IPlannedStockTagWrite[][] = [];

  for (let start = 0; start < stockIds.length; start += STOCK_TAG_BATCH_ITEM_LIMIT) {
    const chunkIds: string[] = stockIds.slice(start, start + STOCK_TAG_BATCH_ITEM_LIMIT);
    const writes: IPlannedStockTagWrite[] = [];

    chunkIds.forEach((stockId: string) => {
      const tags: string[] = taggedItems[stockId];
      writes.push({stockId, tags, target: 'stock'});
      writes.push({stockId, tags, target: 'cache'});
    });

    batches.push(writes);
  }

  return batches;
}
